import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/image_manager.min.js';
import 'froala-editor/js/plugins/inline_class.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/inline_style.min.js';
import 'froala-editor/js/plugins/line_breaker.min.js';
import 'froala-editor/js/plugins/line_height.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/quote.min.js';
import 'froala-editor/js/plugins/save.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/track_changes.min.js';
import 'froala-editor/js/plugins/url.min.js';

import { Dialog } from '@angular/cdk/dialog';
import { Overlay, RepositionScrollStrategy } from '@angular/cdk/overlay';
import { APP_BASE_HREF } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { ErrorHandler, importProvidersFrom, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/button-toggle';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { LuxonDateModule, MAT_LUXON_DATE_FORMATS } from '@angular/material-luxon-adapter';
import { bootstrapApplication, Title } from '@angular/platform-browser';
import { provideRouter, withHashLocation, withRouterConfig } from '@angular/router';
import { SignalRConfiguration, SignalRModule } from '@henkkelder/ng2-signalr';
import { MTX_DATETIME_FORMATS } from '@ng-matero/extensions/core';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { LuxonDatetimeModule, MTX_LUXON_DATETIME_FORMATS, MtxLuxonDatetimeModule } from '@ng-matero/extensions-luxon-adapter';
import { provideEffects } from '@ngrx/effects';
import { MetaReducer, provideStore } from '@ngrx/store';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

import { FullscreenLayoutAreas } from './assets/css/fullscreen.template.scss';
import { AppComponent } from './suite/app.component';
import { AppErrorHandler } from './suite/app.errorhandler';
import { initApp } from './suite/app.init';
import { routes } from './suite/app.routing';
import { HighlightPipe } from './suite/common/pipes/highlight';
import { IsArrayPipe } from './suite/common/pipes/is-array';
import { JwtIncerceptor } from './suite/common/services/interceptors/http-interceptor';
import { breakPointsReducer } from './suite/common/store/breakpoints/breakpoints.reducer';
import { CastStateEffects } from './suite/common/store/cast/cast.effects';
import { castReducer } from './suite/common/store/cast/cast.reducers';
import { CreateViewStateEffects } from './suite/common/store/createviewstate/createviewstate.effects';
import { createViewStateReducer } from './suite/common/store/createviewstate/createviewstate.reducer';
import { errorHandlingMetaReducer } from './suite/common/store/error/handler.meta.reducer';
import { fullscreenNewRecordReducer, fullscreenReducer } from './suite/common/store/fullscreen';
import { FullscreenModalEffects } from './suite/common/store/fullscreen/effects/fullscreen.effects';
import { FullscreenModalSidecarEffects } from './suite/common/store/fullscreen/effects/sidecar.effects';
import { fourthSidecarReducer } from './suite/common/store/fullscreen/reducers/sidecar-fourth.reducer';
import { mainSidecarReducer } from './suite/common/store/fullscreen/reducers/sidecar-main.reducer';
import { secondSidecarReducer } from './suite/common/store/fullscreen/reducers/sidecar-second.reducer';
import { thirdSidecarReducer } from './suite/common/store/fullscreen/reducers/sidecar-third.reducer';
import { GlobalTablesEffects } from './suite/common/store/global-tables/global-tables.effects';
import { globalTablesReducer } from './suite/common/store/global-tables/global-tables.reducers';
import { HelloResultsEffects } from './suite/common/store/hello-results/hello-results.effects';
import { helloResultsReducer } from './suite/common/store/hello-results/hello-results.reducers';
import { i18nReducer } from './suite/common/store/i18n/reducers/i18n.reducers';
import { InlineFilterEffects } from './suite/common/store/inline-filter/inline-filter.effects';
import { inlineFilterReducer } from './suite/common/store/inline-filter/inline-filter.reducer';
import { INLINE_FILTER_FEATURE } from './suite/common/store/inline-filter/inline-filter.selectors';
import { ListEffects } from './suite/common/store/list/list.effects';
import { listReducer } from './suite/common/store/list/list.reducers';
import { MosEffects } from './suite/common/store/mos/effects/mos.effects';
import { mosReducer } from './suite/common/store/mos/reducers/mos.reducer';
import { ApplicationEffects } from './suite/common/store/navigation/effects/application.effects';
import { NavigationEffects } from './suite/common/store/navigation/effects/navigation.effects';
import { ViewStateEffects } from './suite/common/store/navigation/effects/viewstate.effects';
import { applicationMetaReducer, applicationReducer } from './suite/common/store/navigation/reducers/application.reducers';
import { navigationReducer } from './suite/common/store/navigation/reducers/navigation.reducers';
import { viewStateReducer } from './suite/common/store/navigation/reducers/viewstate.reducers';
import { NotesEffects } from './suite/common/store/notes/notes.effects';
import { notesNewRecordReducer, notesReducer } from './suite/common/store/notes/notes.reducers';
import { PlaybookEffects } from './suite/common/store/playbook/playbook.effects';
import { playbookReducer } from './suite/common/store/playbook/playbook.reducers';
import { RecordEffects } from './suite/common/store/records/records.effects';
import {
    assignmentRecordsReducer,
    discoverRecordsReducer,
    notesRecordsReducer,
    publicationRecordsReducer,
    rundownRecordsReducer,
    storiesRecordsReducer,
    topicRecordsReducer,
    userRecordsReducer,
} from './suite/common/store/records/records.reducers';
import { StoryEffects } from './suite/common/store/story/effects/story.effects';
import { storiesReducer } from './suite/common/store/story/reducer/story.reducers';
import { TeamMembersEffects } from './suite/common/store/team-members/team-members.effects';
import { teamMembersReducer } from './suite/common/store/team-members/team-members.reducers';
import { DiscoverEffects } from './suite/discover/store/effects/discover.effects';
import { FeedProviderEffects } from './suite/discover/store/effects/feed.provider.effects';
import { wiresReducer } from './suite/discover/store/reducers/discover.reducer';
import { feedProviderReducer } from './suite/discover/store/reducers/feed.provider.reducer';
import { LiveEffects } from './suite/live/store/effects/live.effects';
import { liveReducer } from './suite/live/store/reducers/live.reducers';

const metaReducers: MetaReducer<any>[] = [errorHandlingMetaReducer, applicationMetaReducer];
export function getSignalRConfiguration() {
    const signalrConfiguration = new SignalRConfiguration();
    return signalrConfiguration;
}

export function scrollFactory(overlay: Overlay): () => RepositionScrollStrategy {
    return () => overlay.scrollStrategies.reposition();
}

ModuleRegistry.registerModules([AllCommunityModule]);

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(SignalRModule.forRoot(getSignalRConfiguration)),
        importProvidersFrom(MatDatepickerModule),
        importProvidersFrom(MtxDatetimepickerModule),
        importProvidersFrom(LuxonDatetimeModule),
        importProvidersFrom(MtxLuxonDatetimeModule),
        importProvidersFrom(LuxonDateModule),
        provideBrowserGlobalErrorListeners(),
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
        provideRouter(
            routes,
            withHashLocation(),
            withRouterConfig({
                onSameUrlNavigation: 'reload',
            })
        ),
        provideStore(
            {
                application: applicationReducer,
                discover: wiresReducer,
                navigation: navigationReducer,
                viewstate: viewStateReducer,
                i18n: i18nReducer,
                stories: storiesReducer,
                mos: mosReducer,
                live: liveReducer,
                feedprovider: feedProviderReducer,
                topicRecords: topicRecordsReducer,
                assignmentRecords: assignmentRecordsReducer,
                storyRecords: storiesRecordsReducer,
                rundownRecords: rundownRecordsReducer,
                userRecords: userRecordsReducer,
                fullscreenDialog: fullscreenReducer,
                fullscreenNewRecordDialog: fullscreenNewRecordReducer,
                createviewstate: createViewStateReducer,
                list: listReducer,
                globalTables: globalTablesReducer,
                helloResults: helloResultsReducer,
                playbook: playbookReducer,
                discoverRecords: discoverRecordsReducer,
                publicationRecords: publicationRecordsReducer,
                [FullscreenLayoutAreas.SIDECAR_MAIN]: mainSidecarReducer,
                [FullscreenLayoutAreas.SIDECAR_SECOND]: secondSidecarReducer,
                [FullscreenLayoutAreas.SIDECAR_THIRD]: thirdSidecarReducer,
                [FullscreenLayoutAreas.SIDECAR_FOURTH]: fourthSidecarReducer,
                cast: castReducer,
                breakPoints: breakPointsReducer,
                notes: notesReducer,
                notesNewRecord: notesNewRecordReducer,
                notesRecords: notesRecordsReducer,
                [INLINE_FILTER_FEATURE]: inlineFilterReducer,
                teamMembers: teamMembersReducer,
            },
            {
                runtimeChecks: {
                    strictStateImmutability: true,
                    strictActionImmutability: true,
                    // strictStateSerializability: true,
                    // strictActionSerializability: true,
                    // strictActionWithinNgZone: true,
                    strictActionTypeUniqueness: true,
                },
                metaReducers,
            }
        ),
        provideEffects([
            ApplicationEffects,
            PlaybookEffects,
            DiscoverEffects,
            NavigationEffects,
            MosEffects,
            StoryEffects,
            LiveEffects,
            FeedProviderEffects,
            FullscreenModalEffects,
            FullscreenModalSidecarEffects,
            RecordEffects,
            ViewStateEffects,
            CastStateEffects,
            CreateViewStateEffects,
            GlobalTablesEffects,
            HelloResultsEffects,
            ListEffects,
            NotesEffects,
            InlineFilterEffects,
            TeamMembersEffects,
        ]),
        provideAppInitializer(initApp),
        {
            provide: ErrorHandler,
            useClass: AppErrorHandler,
        },
        Title,
        { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { position: 'above', showDelay: 1000 } },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'auto', appearance: 'outline' } },
        { provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtIncerceptor,
            multi: true,
        },
        { provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS, useValue: { hideSingleSelectionIndicator: true } },
        { provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS },
        { provide: MTX_DATETIME_FORMATS, useValue: MTX_LUXON_DATETIME_FORMATS },
        { provide: APP_BASE_HREF, useValue: '/' },
        Dialog,
        HighlightPipe,
        IsArrayPipe,
    ],
});
